/* One mutation path for cart page and drawer; Shopify owns all pricing. */
(() => {
  if (window.RedLineCart) return;
  const fr = document.documentElement.lang.startsWith('fr');
  const copy = {
    pending: fr ? 'Mise à jour du panier…' : 'Updating your cart…',
    error: fr ? 'Impossible de confirmer la mise à jour. Réessayez ou actualisez la page avant de payer.' : 'We could not confirm the update. Try again or refresh before checkout.',
    updated: fr ? 'Panier mis à jour.' : 'Cart updated.',
    limited: fr ? 'La quantité a été ajustée à la disponibilité actuelle.' : 'Quantity was adjusted to current availability.'
  };
  const api = window.RedLineCart = {
    pending: false, failed: false, checkout: null,
    sections() {
      const list = [{id:'Cart-Drawer', section:'cart-drawer', selector:'.side-panel-content'}, {id:'cart-drawer-toggle', section:'cart-bubble', selector:'.float_count'}];
      const cart = document.getElementById('Cart');
      if (cart) list.unshift({id:'Cart', section:cart.dataset.id, selector:'.thb-cart-form-container'});
      return list.filter(s => document.getElementById(s.id));
    },
    message(text, error = false) {
      for (const root of document.querySelectorAll('#Cart, #Cart-Drawer .side-panel-content')) {
        let el = root.querySelector('.rl-cart-message');
        if (!el) { el = document.createElement('p'); el.className = 'rl-cart-message'; el.setAttribute('role','status'); el.setAttribute('aria-live','polite'); root.prepend(el); }
        el.textContent = text; el.classList.toggle('error',error);
      }
    },
    busy(value) {
      this.pending = value;
      document.body.classList.toggle('rl-cart-pending',value);
      for (const root of document.querySelectorAll('#Cart, #Cart-Drawer')) {
        root.setAttribute('aria-busy',String(value));
        root.querySelectorAll('.qty,.plus,.minus,.remove,[name="checkout"],.shipping-estimator--submit').forEach(el => {
          if ('disabled' in el) el.disabled = value || (this.failed && el.name === 'checkout');
          el.setAttribute('aria-disabled',String(value));
        });
        root.querySelectorAll('.additional-checkout-buttons').forEach(el => el.inert = value || this.failed);
      }
    },
    async refresh() {
      const url = new URL(location.href); url.searchParams.set('sections',this.sections().map(s=>s.section).join(','));
      const response = await fetch(url,{cache:'no-store',signal:AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error(copy.error);
      this.render(await response.json());
    },
    render(sections) {
      const active = document.activeElement;
      const activeKey = this.focusContext?.key || active?.dataset.key || active?.closest('quantity-selector')?.querySelector('.qty')?.dataset.key;
      const activeRoot = this.focusContext?.root || active?.closest('#Cart, #Cart-Drawer')?.id;
      const activeClass = this.focusContext?.control || (active?.classList.contains('plus') ? '.plus' : active?.classList.contains('minus') ? '.minus' : '.qty');
      const retained = [...document.querySelectorAll('#CartSpecialInstructions,#mini-cart__notes,#CartTerms,#CartDrawerTerms')].map(el=>({id:el.id,value:el.value,checked:el.checked}));
      const estimator = document.querySelector('shipping-estimator');
      const destination = estimator ? ['country','province','zip'].map(x=>estimator.querySelector('.shipping-estimator-'+x)?.value) : null;
      for (const section of this.sections()) {
        if (!sections[section.section]) throw new Error(copy.error);
        const next = new DOMParser().parseFromString(sections[section.section],'text/html').querySelector(section.selector);
        const root = document.getElementById(section.id);
        const target = root.querySelector(section.selector) || root;
        if (!next) throw new Error(copy.error);
        target.innerHTML = next.innerHTML;
      }
      for(const saved of retained){const el=document.getElementById(saved.id);if(el){el.value=saved.value;if(el.type==='checkbox')el.checked=saved.checked;}}
      const nextEstimator = document.querySelector('shipping-estimator');
      if (nextEstimator && destination) {
        ['country','province','zip'].forEach((name,i)=>{
          const input=nextEstimator.querySelector('.shipping-estimator-'+name);
          if (input && destination[i] != null) { input.value=destination[i]; if(name==='country') input.dispatchEvent(new Event('change')); }
        });
      }
      document.querySelector('#Cart-Drawer')?.cartDrawerInstance?.notesToggle();
      const toggle=document.getElementById('cart-drawer-toggle');
      if(toggle)toggle.setAttribute('aria-label',`${fr?'Panier':'Cart'} (${toggle.querySelector('.float_count')?.textContent.trim() || '0'})`);
      if (activeKey) {
        const root=document.getElementById(activeRoot);
        const input=[...(root?.querySelectorAll('.qty') || [])].find(x=>x.dataset.key===activeKey && x.getClientRects().length);
        (input?.closest('quantity-selector')?.querySelector(activeClass) || input)?.focus({preventScroll:true});
      }
    },
    async change(key, quantity) {
      if (this.pending) return;
      if (!key || !Number.isInteger(quantity) || quantity < 0) { document.querySelectorAll('.qty[data-key]').forEach(el=>{if(el.dataset.key===key)el.value=el.dataset.confirmed;});this.message(copy.error,true); return; }
      const active=document.activeElement;
      this.focusContext={key,root:active?.closest('#Cart,#Cart-Drawer')?.id,control:active?.classList.contains('plus')?'.plus':active?.classList.contains('minus')?'.minus':'.qty'};
      this.failed=false; this.busy(true); this.message(copy.pending);
      document.querySelectorAll('shipping-estimator').forEach(el=>el.invalidate?.());
      try {
        const response=await fetch(theme.routes.cart_change_url,{signal:AbortSignal.timeout(15000),method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity,sections:this.sections().map(s=>s.section),sections_url:location.pathname})});
        const state=await response.json();
        if (!response.ok || state.errors || state.status) { const error=new Error(copy.error);error.publicMessage=typeof state.description==='string'?state.description:typeof state.errors==='string'?state.errors:copy.error;throw error; }
        this.render(state.sections);
        const accepted=state.items.find(item=>item.key===key)?.quantity || 0;
        this.message(accepted===quantity?copy.updated:copy.limited);
        document.dispatchEvent(new CustomEvent('line-item:change:end',{detail:{quantity:accepted,cart:state}}));
      } catch (error) {
        this.checkout=null;
        try { await this.refresh(); } catch (_) { this.failed=true; }
        this.message(error.publicMessage || copy.error,true);
      } finally {
        this.busy(false); this.focusContext=null;
        const checkout=this.checkout; this.checkout=null;
        if(checkout && !this.failed) this.submit(checkout);
      }
    },
    submit(rootId) {
      const root=document.getElementById(rootId);
      const button=root?.querySelector('[name="checkout"]');
      const terms=root?.querySelector('#CartTerms,#CartDrawerTerms');
      if(terms && !terms.checked) { terms.reportValidity(); terms.focus(); return; }
      if(button?.form) button.form.requestSubmit(button);
    }
  };
  document.addEventListener('change',event=>{
    const input=event.target;
    if(!input.matches('#Cart .qty,#Cart-Drawer .qty')) return;
    event.stopImmediatePropagation();
    api.change(input.dataset.key,Number(input.value));
  },true);
  document.addEventListener('click',event=>{
    const root=event.target.closest('#Cart,#Cart-Drawer'); if(!root)return;
    const remove=event.target.closest('.remove');
    if(remove){event.preventDefault();event.stopImmediatePropagation();api.change(remove.dataset.key,0);return;}
    if(api.pending && event.target.closest('quantity-selector,.additional-checkout-buttons')) {event.preventDefault();event.stopImmediatePropagation();return;}
    if(event.target.closest('[name="checkout"]') && (api.pending||api.failed)) {
      event.preventDefault();event.stopImmediatePropagation();if(api.pending)api.checkout=root.id;else api.message(copy.error,true);
    }
  },true);
  document.addEventListener('submit',event=>{
    const root=event.target.closest('#Cart,#Cart-Drawer'); if(!root)return;
    if(api.pending||api.failed) {event.preventDefault();event.stopImmediatePropagation();if(api.pending)api.checkout=root.id;else api.message(copy.error,true);return;}
    const terms=root.querySelector('#CartTerms,#CartDrawerTerms');
    if(terms&&!terms.checked){event.preventDefault();terms.reportValidity();terms.focus();}
  },true);
  document.addEventListener('cart:refresh',()=>{if(!api.pending)api.refresh().catch(()=>api.message(copy.error,true));});
})();
